export default __webpack_public_path__ + "static/media/AltCheck.87be1089.svg";